/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.sunnahsky.richtext.facets.formatting'

type $nsid = typeof $nsid

export { $nsid }

/** Specifies the sub-string range a facet feature applies to. Start index is inclusive, end index is exclusive. Indices are zero-indexed, counting bytes of the UTF-8 encoded text. NOTE: some languages, like Javascript, use UTF-16 or Unicode codepoints for string slice indexing; in these languages, convert to byte arrays before working with facets. Byte slices can overlap. */
type ByteSlice = {
  $type?: 'com.sunnahsky.richtext.facets.formatting#byteSlice'
  byteEnd: number
  byteStart: number
}

export type { ByteSlice }

/** Specifies the sub-string range a facet feature applies to. Start index is inclusive, end index is exclusive. Indices are zero-indexed, counting bytes of the UTF-8 encoded text. NOTE: some languages, like Javascript, use UTF-16 or Unicode codepoints for string slice indexing; in these languages, convert to byte arrays before working with facets. Byte slices can overlap. */
const byteSlice = /*#__PURE__*/ l.typedObject<ByteSlice>(
  $nsid,
  'byteSlice',
  /*#__PURE__*/ l.object({
    byteEnd: /*#__PURE__*/ l.integer({ minimum: 0 }),
    byteStart: /*#__PURE__*/ l.integer({ minimum: 0 }),
  }),
)

export { byteSlice }

/** Facet feature applying a text color to the underlying span. For the byteSlice provided it should surround the underlying text. */
type Color = {
  $type?: 'com.sunnahsky.richtext.facets.formatting#color'

  /**
   * A CSS-compatible color value, e.g. a hex string like #1A2B3C. SECURITY: this lexicon has no way to constrain the string's actual syntax (atproto has no regex/pattern validator) - any consuming renderer MUST treat this value as untrusted user input and allowlist it (e.g. #RRGGBB/#RGB plus a fixed keyword set) before interpolating it into a style. Never pass it through raw - doing so is a CSS-injection vector.
   */
  value: string
}

export type { Color }

/** Facet feature applying a text color to the underlying span. For the byteSlice provided it should surround the underlying text. */
const color = /*#__PURE__*/ l.typedObject<Color>(
  $nsid,
  'color',
  /*#__PURE__*/ l.object({ value: /*#__PURE__*/ l.string({ maxLength: 32 }) }),
)

export { color }

/** Span-level rich-text facets not covered by at.markpub.facets.baseFormatting - underline and text color. Same index/features shape as at.markpub.facets.baseFormatting, kept as a separate lexicon rather than a fork of it. */
type Main = {
  $type?: 'com.sunnahsky.richtext.facets.formatting'
  features: (l.$Typed<Underline> | l.$Typed<Color> | l.Unknown$TypedObject)[]
  index: ByteSlice
}

export type { Main }

/** Span-level rich-text facets not covered by at.markpub.facets.baseFormatting - underline and text color. Same index/features shape as at.markpub.facets.baseFormatting, kept as a separate lexicon rather than a fork of it. */
const main = /*#__PURE__*/ l.typedObject<Main>(
  $nsid,
  'main',
  /*#__PURE__*/ l.object({
    features: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.typedUnion(
        [
          /*#__PURE__*/ l.typedRef<Underline>((() => underline) as any),
          /*#__PURE__*/ l.typedRef<Color>((() => color) as any),
        ],
        false,
      ),
    ),
    index: /*#__PURE__*/ l.ref<ByteSlice>((() => byteSlice) as any),
  }),
)

export { main }

const $type = $nsid

type $type = typeof $type

export { $type }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main)
export const $build = /*#__PURE__*/ main.build.bind(main)
export const $assert = /*#__PURE__*/ main.assert.bind(main)
export const $check = /*#__PURE__*/ main.check.bind(main)
export const $cast = /*#__PURE__*/ main.cast.bind(main)
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main)
export const $matches = /*#__PURE__*/ main.matches.bind(main)
export const $parse = /*#__PURE__*/ main.parse.bind(main)
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main)
export const $validate = /*#__PURE__*/ main.validate.bind(main)
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)

/** Facet feature for an underlined span. For the byteSlice provided it should surround the underlying text. */
type Underline = {
  $type?: 'com.sunnahsky.richtext.facets.formatting#underline'
}

export type { Underline }

/** Facet feature for an underlined span. For the byteSlice provided it should surround the underlying text. */
const underline = /*#__PURE__*/ l.typedObject<Underline>(
  $nsid,
  'underline',
  /*#__PURE__*/ l.object({}),
)

export { underline }
